module.exports = __webpack_public_path__ + "static/media/VP.bbb9a038.pptx";